import styled from 'styled-components';
import { color, screen, spacing } from 'theme';

export const Root = styled.div`
  background: ${color('indigo_700')};
  padding: ${spacing('xl4')} 0;
  color: #fff;
`;

export const Intro = styled.div`
  text-align: center;
  max-width: 55rem;
  margin: auto;

  h3 {
    margin-top: 1.5rem;
  }

  p {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }

  span[mode='light'] {
    background: #fff;
  }
`;

export const Badge = styled.div`
  background: ${color('indigo_700')};
  color: #fff;
  font-size: 1.25rem;
  text-transform: uppercase;
  padding: 0.5rem;
  font-weight: 900;
  letter-spacing: 4px;
  display: inline-flex;
  border-radius: 5px;
  word-break: break-word;
`;

export const FeatureWrapper = styled.div`
  padding: 0 1rem;
`;

export const FeatureContent = styled.div`
  background: ${color('sun_100')};
  padding: 2.5rem;
  border-radius: 10px;
  max-width: 60%;

  @media (max-width: ${screen('lg')}) {
    max-width: 100%;
  }

  h4 {
    line-height: 1.25;
  }
`;

export const Feature = styled.div`
  background: #fff;
  background-size: cover;
  box-shadow: 0px 7.57px 11.35px 0px #261a191a;
  box-shadow: 0px 3.03px 4.54px 0px #261a190d;
  padding: 2.5rem;
  border-radius: 10px;
  min-height: 500px;

  @media (max-width: ${screen('lg')}) {
    padding: 0;
    background: none !important;
    min-height: auto;
  }

  h4 {
    margin: 1.5rem 0;
    color: #000;
  }

  h5 {
    margin-bottom: 0;
  }

  p {
  }
`;
